// welcome.js
import selfHtml from './s00-welcome.html' with { type: 'text' };;

import { MsgComposeModule, InviteModule, ComparisonsModule, mod_loader } from '../AppState';

//import { get_pub_key } from "../crypt_helper.js"; 
//import { showOffcanvas } from "../utils.js";

var root

export async function init(module_root, args) {

        module_root.innerHTML = selfHtml;

        root = module_root

        root.querySelector(".btn_welcome_request").addEventListener('click', () => mod_loader(InviteModule));

        root.querySelector(".btn_welcome_write").addEventListener('click', () => mod_loader(MsgComposeModule));

        $e(root).getEl("btn_comparison").addEventListener('click', () => mod_loader(ComparisonsModule));

}
 